import React from 'react';
import styled from 'styled-components';
import { useLayout } from '../context/LayoutContext';

interface PageContainerLayoutProps {
  children: React.ReactNode;
  className?: string;
  mobilePaddingTop?: number; // 모바일에서 패딩 탑 값 (px)
}

const PageContainer = styled.div<{ $isFullWidth?: boolean; $mobilePaddingTop?: number }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  padding-top: 90px;
  max-width: ${props => props.$isFullWidth ? 'none' : '500px'}; 
  margin: 0 auto;
  min-height: calc(100vh - 150px);
  box-sizing: border-box;

  @media (max-width: 768px) {
    max-width: none; /* 모바일에서는 최대 너비 제한 해제 */
    min-height: auto; /* min-height 제거하여 콘텐츠 길이에 맞춤 */
    padding-top: ${props => props.$mobilePaddingTop !== undefined ? `${props.$mobilePaddingTop}px` : '32px'};
    padding-bottom: 32px; /* 바텀 네비게이션 높이 + 여유 공간 */
  
  }
`;

const PageContainerLayout: React.FC<PageContainerLayoutProps> = ({ 
  children, 
  className,
  mobilePaddingTop
}) => {
  const { isFullWidth } = useLayout();
  
  return (
    <PageContainer 
      className={className} 
      $isFullWidth={isFullWidth}
      $mobilePaddingTop={mobilePaddingTop}
    >
      {children}
    </PageContainer>
  );
};

export default PageContainerLayout;
